export default "__VITE_ASSET__CH9id$ih__"